import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PolicyPage.module.scss';
import clsx from 'clsx';
import SimpleContent from '../../components/SimpleContent/SimpleContent';
import Layout from '../../components/Layout/Layout';
const PolicyPage = () => {
  return (
    <>
      <>
        <SimpleContent title="Политика конфиденциальности">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus ea provident eius quod obcaecati quam odio harum blanditiis, quibusdam nesciunt, laudantium, vitae assumenda omnis ipsum id ullam exercitationem ducimus repellat quae! Quibusdam natus minima nam, corporis
            voluptatibus cum delectus repudiandae, rerum dolorum ad voluptate dicta expedita rem minus, accusamus provident fugit reiciendis aperiam nemo recusandae non odit facilis ipsa esse. Nulla voluptate nobis officiis doloribus, necessitatibus beatae omnis possimus officia ad blanditiis sunt
            aspernatur dolores perferendis deserunt! Quasi, officiis quidem quo quia amet maxime perspiciatis autem magni in accusantium est et aperiam mollitia tenetur sed. Maxime, aperiam hic. Voluptatum, excepturi!
          </p>
        </SimpleContent>
      </>
    </>
  );
};

export default PolicyPage;
